import(/* webpackMode: "eager" */ "/var/www/safiruni/front/app/[lang]/general-faculties/page.tsx");
